module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan2-3-ea124d711a0543aaf3cbaa5fa688fc95.webp";